import { API_URL } from "../../../../constants";
import * as httpNetworking from "../../../../httpNetworking";

const URL = API_URL + "/st/core/latest";
const VERSION = 0;

export type GetLatestCoreVersionPayload = { region: string; deploymentType: "development" | "production" };

export default async function getLatestCoreVersion(
    params: GetLatestCoreVersionPayload
): Promise<{ coreVersion: string }> {
    let options: httpNetworking.GETRequestConfig = {
        timeout: 50000,
        params
    };

    let response = (await httpNetworking.simpleGETRequest(URL, options, VERSION)).data;
    return response;
}
